import React from 'react';
import PropTypes from 'prop-types';

export function SortSelectorComponent({ handleChange, selectedValue, children }) {
  return (
    <select
      className="form-control"
      name="sort"
      onChange={handleChange}
      value={selectedValue}
    >
      {children}
    </select>
  );
}

SortSelectorComponent.propTypes = {
  selectedValue: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.bool,
    ]),
  ).isRequired,
};

export default SortSelectorComponent;



// WEBPACK FOOTER //
// ./src/components/SortSelector/SortSelector.js